<template>
    <div>
        <v-row justify="center" class="bg-color-teal-900">
            <v-col cols="0" sm="2"></v-col>
            <v-col cols="12" sm="8">
                <v-row>
                    <v-container>
                        <div class="body-text text-white mt-4">
                            <p class="text-h4 font-weight-light">
                                <LanguagePlaceholder is-html default-text="Distributor Referral Report" />
                            </p>
                            <br />
                            <p>
                                <b>WHAT is this report: </b>
                                This report shows all partners who registered under your sponsorship.
                                <br /><br />
                                <b>HOW do you use it: </b>
                                Use this report to track partners you have referred to the RISE programme.
                            </p>
                            <PleaseNote></PleaseNote>
                        </div>
                    </v-container>
                </v-row>
                <v-row class="my-2 gap-2" align="center">
                    <div>
                        <v-btn prepend-icon="mdi-download" @click="downloadFile" color="white" variant="outlined"
                            aria-label="Download Report">
                            <LanguagePlaceholder default-text="Download" />
                        </v-btn>
                    </div>
                </v-row>
            </v-col>
            <v-col cols="0" sm="2"></v-col>
        </v-row>
        <v-row justify="center" style="background-color: #ffffff;" class="pb-6">
            <v-container>
                <v-card flat>
                    <v-text-field v-model="searchString" label="Filter" prepend-inner-icon="mdi-filter-outline"
                        variant="outlined" hide-details single-line
                        aria-label="Filter distributor referral data"></v-text-field>

                    <v-data-table items-per-page="50" :search="searchString" :headers="headers" :items="reportData"
                        class="v-data-table" role="table" aria-label="Distributor referral report data">
                    </v-data-table>
                </v-card>
            </v-container>
        </v-row>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import { useSystemStore } from '@/stores/system'
import { useExcelStore } from '@/stores/excel'
import PleaseNote from '@/components/PleaseNote.vue'

const systemStore = useSystemStore()
const excelStore = useExcelStore()

const reportData = ref([])
const searchString = ref('')

const headers = [
    { title: 'Partner Name', value: 'partnerName', sortable: true, headerProps: { class: 'header-style' } },
    { title: 'Partner Id', value: 'partnerAffinityId', sortable: true, headerProps: { class: 'header-style' } },
    { title: 'Country', value: 'country', sortable: true, headerProps: { class: 'header-style' } },
    { title: 'Sponsored Distributor', value: 'sponsoredDistributorName', sortable: true, headerProps: { class: 'header-style' } },
    { title: 'Distributor Id', value: 'sponsoredDistributorAffinityId', sortable: true, headerProps: { class: 'header-style' } },
    { title: 'Channel', value: 'sponsoredDistributorChannel', sortable: true, headerProps: { class: 'header-style' } },
]

onMounted(() => {
    loadReportData()
})

const loadReportData = () => {
    systemStore.getDistributorReferralReport().then(result => {
        if (result.success) {
            reportData.value = result.reportData ?? []
        }
    }).catch(error => {
        console.log('getDistributorReferralReport', error)
    })
}

const downloadFile = () => {
    if (reportData.value.length === 0) {
        return
    }

    excelStore.generateInMemoryExcelDocument(reportData.value, 'DistributorReferralDocument').catch(error => {
        console.log('Generate In Memory Excel Document - DistributorReferralDocument', error)
    })
}
</script>

<style>
.header-style {
    background-color: #004D40 !important;
    color: white;
}

.header-style:hover {
    color: white !important;
}

.v-data-table tbody tr:nth-child(even) {
    background-color: #e0e6ec;
    color: #202520;
}

.v-data-table tbody tr:nth-child(odd) {
    background-color: whitesmoke;
    color: #202520;
}
</style>
